import { Route, Routes } from 'react-router-dom';
import { AppShell } from './AppShell';
import { ProjectStoreProvider } from './projectStore';
import { ToastProvider } from '@/components/Toast';
import { ProjectsPage } from '@/features/projects/ProjectsPage';
import { ProjectPage } from '@/features/projects/ProjectPage';
import { WizardPage } from '@/features/wizard/WizardPage';
import { ReportPage } from '@/features/report/ReportPage';
import { NotFoundPage } from './NotFoundPage';

export function App() {
  return (
    <ToastProvider>
      <ProjectStoreProvider>
        <Routes>
          <Route element={<AppShell />}>
            <Route index element={<ProjectsPage />} />
            <Route path="p/:projectId" element={<ProjectPage />} />
            <Route path="p/:projectId/wizard" element={<WizardPage />} />
            <Route path="p/:projectId/report" element={<ReportPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Route>
        </Routes>
      </ProjectStoreProvider>
    </ToastProvider>
  );
}
